import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';

import './GoBack.scss';

@inject('AppState')
export default class GoBack extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
		goBackText: PropTypes.string.isRequired,
	};

	MIN_HISTORY_LENGTH = 1;

	goBack() {
		if (this.props.AppState.locations.length > this.MIN_HISTORY_LENGTH) {
			this.props.history.goBack();
		} else {
			this.props.history.push('/');
		}
	}

	render() {
		return (
			<div
				className="col-md-6 GoBack"
				onClick={this.goBack.bind(this)}
				id="GoBack"
			>
				<p>
					<FormattedMessage id={this.props.goBackText} />
				</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/GoBack/index.js